"use client";

import {
	ListItem,
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import cn from "@/lib/cn";
import Link from "next/link";
import { usePathname } from "next/navigation";

const CategoriesMenu = (props: { items: { name: string; url: string }[] }) => {
	const pathname = usePathname();
	const isActive = pathname === "/categories";

	return (
		<NavigationMenu>
			<NavigationMenuList>
				<NavigationMenuItem>
					<NavigationMenuTrigger className={cn(isActive ? "text-brand-primary" : "text-gray-700")}>
						<div className="relative">
							<div>
								<span className="absolute -right-4 -top-3.5 z-0">
									<span className="animate-pulse rounded-lg bg-red-500 px-[5px] py-[1px] text-xxs text-white">
										HOT
									</span>
								</span>

								<Link
									href="/categories"
									className={cn("z-10 rounded-md text-sm font-normal hover:text-brand-primary")}
								>
									Categories
								</Link>
							</div>
						</div>
					</NavigationMenuTrigger>
					<NavigationMenuContent>
						<ul className="grid gap-1 bg-white p-4">
							{props.items.map((e, i) => (
								<ListItem key={i} title={e.name} href={e.url} />
							))}
						</ul>
					</NavigationMenuContent>
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>
	);
};

export default CategoriesMenu;
